// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xCLq","title":"styles_title__39fyt"};